import styled from 'styled-components'

export const ContainerLinks = styled.div`
  padding-top: 16px;

  > div {
    padding: 20px 20px 20px 25px;
  }

  .action-email {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    > div {
      padding: 0;
    }
  }
`

export const ContainerDigitalSignatures = styled.div`
  width: 100%;
  margin: auto;

  > div {
    max-width: 100% !important;
    > div {
      max-width: 100% !important;
    }
  }
`

export const ActionButtonContainer = styled.div`
  width: 100%;
  margin: 40px 0;

  > button {
    margin-left: auto !important;
  }

  .disabled {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
`

export const ButtonUpdateSignContainer = styled.div`
  padding-bottom: 20px;
  > button {
    margin-left: auto !important;
  }
`

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 16px 0;
`

export const GridRow = styled.div`
  width: 48%;

  .DFtextField {
    margin: 0;
  }
`

export const Actions = styled.div`
  margin-bottom: 24px;
  width: 100%;

  * {
    box-sizing: border-box;
  }

  .actions-item {
    width: 100%;
    display: flex;
    justify-content: flex-end;

    > div {
      padding: 0;
      margin-bottom: 16px;
    }
  }
`

export const EmissionContainer = styled.div`
  display: flex;
  gap: 32px;

  > div {
    margin-left: 40px;
    width: 50%;
  }
`

export const PaymentMethodTitle = styled.div`
  margin: auto;
  max-width: 600px;
`

export const PaymentMethodContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 32px;
  justify-content: center;

  .DFradioField {
    text-align: left;
  }
`

export const DocumentationContainer = styled.div`
  width: 100%;
  margin: auto;
  margin-bottom: 60px;

  > div {
    max-width: 600px;
    align-items: center;
    justify-content: center;
  }
`

export const DocumentsContainer = styled.div`
  padding-top: 16px;
  width: 50%;
  margin: auto;
  > div {
    padding: 20px 20px 20px 25px;
  }

  .action-email {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    > div {
      padding: 0;
    }
  }

  .checkbox-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0;

    div:first-child {
      margin: 0;
      width: 40px;
    }
    div:last-child {
      width: auto;
      padding-top: 6px;
      padding-bottom: 6px;
    }
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;

  .submitButton {
    margin: 0;
  }
`

export const ExpandedLoading = styled.div`
  position: absolute;
  width: 100%;
  height: 80%;
  background: rgba(255, 255, 255, 0.8);
  z-index: 99;
`

export const DigitalSignaturesSelectionContainer = styled.div`
  .tbody {
    position: relative;
  }

  .cancel-button {
    display: flex;
    justify-content: flex-end;

    button {
      margin-right: 0;
    }
  }
`
